<div class="ribbon ribbon-top-right">
  <span>
    <div>Demo Mode</div>
  </span>
</div>
